import { Text } from 'common-components'
import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const VolumeSliderContainer = styled.div``

export const MuteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  & > svg {
    width: 16px;
    height: 16px;
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover > svg {
    fill: ${COLORS.secondaryDark};
  }
`

export const VolumeSliderWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  height: 16px;
`

export const VolumePercent = styled(Text)`
  min-width: 36px;
  font-variant-numeric: tabular-nums;
  text-align: end;
  margin-left: 2px;
`
